import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { composeFormData } from '@/utils'

import { TrainerServicePayload } from './create-trainer'
import { Trainer, useInvalidateTrainers } from './get-trainers'

export type UpdateTrainerRequest = {
  active?: boolean
  apartment?: string
  avatar?: File
  firstName?: string
  gender?: string
  id: number
  lastName?: string
  phone?: string
  // Note: BE replaces the whole list, and ignores an empty one - it can never be cleared
  services?: TrainerServicePayload[]
  street?: string
  zipCode?: string
}

export const updateTrainer = async ({ id, ...data }: UpdateTrainerRequest) => {
  const response = await authAPI.put<Trainer>(`/trainer/${id}`, composeFormData(data), {
    headers: { 'content-type': 'multipart/form-data' },
  })
  return response.data
}

export const useUpdateTrainer = () => {
  const invalidateTrainers = useInvalidateTrainers()

  return useMutation({
    mutationFn: updateTrainer,
    onSuccess: invalidateTrainers,
  })
}
